module.exports = __webpack_public_path__ + "img/founders-three.6df4d42f.png";